import { Button, Theme } from "@mui/material";
import { createStyles, makeStyles } from "@mui/styles";
import React, { useState } from "react";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      margin: theme.spacing(2),
    },
    leftSm: {
      height: 36,
      borderTopRightRadius: 0,
      borderBottomRightRadius: 0,
    },
    leftXs: {
      height: 28,
      borderTopRightRadius: 0,
      borderBottomRightRadius: 0,
    },
    rightSm: {
      height: 36,
      borderTopLeftRadius: 0,
      borderBottomLeftRadius: 0,
    },
    rightXs: {
      height: 28,
      borderTopLeftRadius: 0,
      borderBottomLeftRadius: 0,
    },
  })
);

interface BinaryButtonProps {
  onLeftClick: () => void;
  onRightClick: () => void;
  leftLabel: string;
  rightLabel: string;
  size?: "xs" | "sm";
  initialLeftOrRight?: "left" | "right";
}

const BinaryButton = ({
  onLeftClick,
  onRightClick,
  leftLabel,
  rightLabel,
  size = "sm",
  initialLeftOrRight = "left",
}: BinaryButtonProps) => {
  const classes = useStyles();
  const [leftOrRight, setLeftOrRight] = useState<"left" | "right">(initialLeftOrRight);
  return (
    <div className={classes.root}>
      <Button
        size="small"
        className={size === "sm" ? classes.leftSm : classes.leftXs}
        onClick={() => {
          setLeftOrRight("left");
          onLeftClick();
        }}
        variant={leftOrRight === "left" ? "contained" : "outlined"}
      >
        {leftLabel}
      </Button>
      <Button
        size="small"
        className={size === "sm" ? classes.rightSm : classes.rightXs}
        onClick={() => {
          setLeftOrRight("right");
          onRightClick();
        }}
        variant={leftOrRight === "right" ? "contained" : "outlined"}
      >
        {rightLabel}
      </Button>
    </div>
  );
};

export default BinaryButton;
